var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRecentActivity(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m15 14.75a.74.74 0 0 1 -.42-.13l-3-2a.76.76 0 0 1 -.33-.62v-5a.75.75 0 0 1 1.5 0v4.6l2.67 1.78a.75.75 0 0 1 -.42 1.37z",
    fill: "#c6ebbe"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12 2.25a9.68 9.68 0 0 0 -6.75 2.75v-2a.75.75 0 0 0 -1.5 0v4a.76.76 0 0 0 .75.75h4a.75.75 0 0 0 0-1.5h-2.4a8.24 8.24 0 1 1 -2.35 5.75.75.75 0 0 0 -1.5 0 9.75 9.75 0 1 0 9.75-9.75z",
    fill: "#00a0ed"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecentActivity);
export default __webpack_public_path__ + "static/media/recent-activity.f0188b63f578f3020eba84f81c1ebeb4.svg";
export { ForwardRef as ReactComponent };